import { render, staticRenderFns } from "./soil.vue?vue&type=template&id=5444e489&scoped=true"
import script from "./soil.vue?vue&type=script&lang=js"
export * from "./soil.vue?vue&type=script&lang=js"
import style0 from "./soil.vue?vue&type=style&index=0&id=5444e489&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5444e489",
  null
  
)

export default component.exports